/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Root_Error_Boundary_TitleInputs */

const en_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application failed to initialize`)
};

const de_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendung konnte nicht initialisiert werden`)
};

const pt_br2_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao inicializar o aplicativo`)
};

const tr_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulama başlatılamadı`)
};

const zh_cn2_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用初始化失败`)
};

const zh_hk2_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`應用程式初始化失敗`)
};

const ko_kr2_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`애플리케이션 초기화 실패`)
};

const ru_ru2_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось инициализировать приложение`)
};

const es_419_components_root_error_boundary_title = /** @type {(inputs: Components_Root_Error_Boundary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La aplicación no se pudo inicializar`)
};

/**
* | output |
* | --- |
* | "Application failed to initialize" |
*
* @param {Components_Root_Error_Boundary_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_root_error_boundary_title = /** @type {((inputs?: Components_Root_Error_Boundary_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Root_Error_Boundary_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_root_error_boundary_title(inputs)
	if (locale === "de") return de_components_root_error_boundary_title(inputs)
	if (locale === "pt-BR") return pt_br2_components_root_error_boundary_title(inputs)
	if (locale === "tr") return tr_components_root_error_boundary_title(inputs)
	if (locale === "zh-CN") return zh_cn2_components_root_error_boundary_title(inputs)
	if (locale === "zh-HK") return zh_hk2_components_root_error_boundary_title(inputs)
	if (locale === "ko-KR") return ko_kr2_components_root_error_boundary_title(inputs)
	if (locale === "ru-RU") return ru_ru2_components_root_error_boundary_title(inputs)
	return es_419_components_root_error_boundary_title(inputs)
});